import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Maybe from "components/__new/common/Maybe";
import useEmptyData from "hooks/useEmptyData";
import { ReactComponent as IconSearch } from "assets/images/icons/icon-search.svg";


const BeneficiariesList = ({selectBeneficiary, loading, beneficiaries}) => {
    const [keyword, setKeyword] = useState("");
    const { SearchBeneficiariesEmptyData, ListBeneficiariesEmptyData } = useEmptyData();
    
    const filteredBeneficiaries = beneficiaries?.filter((beneficiary) => {
        if(keyword === "") {
            return true
        } else {
            return beneficiary?.accountName?.toLowerCase()?.includes(keyword?.toLowerCase()) ||
                beneficiary?.bankName?.toLowerCase()?.includes(keyword?.toLowerCase()) || beneficiary?.accountNumber?.includes(keyword);
        }
    })
    
    return (
        <div style={{
                position: "absolute",
                right: "-340px",
                height: "300px",
                top: "-150px" 
            }}
            className="overflow-y-scroll text-sm modal-list-wrap bg-white top-0 w-[300px] rounded-lg">
            
            <Maybe condition={loading === true}>
                <div className="py-5 text-center mt-8">
                    <div className="font-medium">
                        Fetching beneficiaries
                    </div>
                    <div className="mt-4 flex justify-center">
                        <FontAwesomeIcon icon="circle-notch" spin className="text-2xl" />
                    </div>
                </div>
            </Maybe>
            
            <ListBeneficiariesEmptyData
                condition={loading === false && beneficiaries?.length === 0}
            />
            
            <Maybe condition={loading === false && beneficiaries?.length > 0}>
                <div className="w-full bg-white sticky top-0 left-0 p-4">
                    <div className="w-full relative">
                        <input
                            type="text"
                            value={keyword}
                            placeholder='Search Beneficiaries' 
                            onChange={(e) => setKeyword(e.target.value)}
                            className='bg-[#f3f4f6] w-full relative text-xs pl-9 !border-0 !ring-0 rounded-lg form-input'
                        />
                        
                        <IconSearch className='absolute left-2 top-2.5' width={18} />
                    </div>
                </div>
                    
                <SearchBeneficiariesEmptyData 
                    condition={keyword?.length > 0 && filteredBeneficiaries?.length === 0}
                />
                
                <div className="w-full p-4 pt-1">
                    <div>
                        {filteredBeneficiaries?.map((beneficiary, index) => ( 
                            <div onClick={() => selectBeneficiary(beneficiary)} key={index} className="mb-2.5 pb-2 border-b cursor-pointer">
                                <div className="font-medium capitalize text-[#374151]">{beneficiary?.accountName?.toLowerCase()}</div>
                                
                                <div className="flex items-center pt-1 text-gray-500">
                                    <div>{beneficiary?.accountNumber}</div>
                                    <span className='h-1 w-1 rounded-full bg-gray-500 mx-1' />
                                    <div>{beneficiary?.bankName}</div>
                                </div>
                            </div>
                            )
                        )}
                    </div>
                </div>
            </Maybe>
            
            <div className='sticky bottom-0 h-2 bg-white w-full left-0' />
        </div>
    )
}

export default BeneficiariesList